import type CK from '~/types/contentking';

import {
	useAccountIsPartnerQuery,
} from './useAccountIsPartner.gql';

import useAccountPropertiesQuery from '~/hooks/useAccountPropertiesQuery';



function useAccountIsPartner(accountId: CK.AccountId | null) {
	const { data } = useAccountPropertiesQuery(
		useAccountIsPartnerQuery,
		accountId,
	);

	return data?.account?.isPartner ?? null;
}



export default useAccountIsPartner;
